import { Quote } from "lucide-react";
import { TESTIDS } from "@/lib/site";
import { useReveal } from "@/lib/useReveal";

const TESTIMONIALS = [
  {
    text: "Llegué con muchísima ansiedad y la sensación de no poder ponerle palabras a lo que sentía. La musicoterapia me dio un lugar para empezar a nombrarlo, desde otro lado, más honesto.",
    name: "Ana Sofía R.",
    role: "Paciente · Sesiones en línea",
    tone: "rose",
  },
  {
    text: "Berenice te sostiene con una calidez que se siente real. No te juzga, te escucha. Salí de cada sesión más cerca de mí.",
    name: "Mariana L.",
    role: "Proceso individual",
    tone: "sage",
  },
  {
    text: "Pensé que iba a sentirme rara por no saber música, y fue todo lo contrario. Es un espacio sensible, profesional, sin prisas.",
    name: "Carolina T.",
    role: "Musicoterapia humanista",
    tone: "lavender",
  },
  {
    text: "Encontré, por primera vez, un espacio donde mi neurodivergencia no es una etiqueta, es parte de mi historia. Eso lo cambió todo.",
    name: "Diego H.",
    role: "Proceso individual",
    tone: "beige",
  },
];

const TONES = {
  rose: "bg-dusty-rose/25 border-dusty-rose/40",
  sage: "bg-sage/25 border-sage/40",
  lavender: "bg-lavender/30 border-lavender/50",
  beige: "bg-warm-beige/70 border-warm-beige",
};

export default function Testimonials() {
  const r = useReveal();
  return (
    <section
      id="testimonios"
      data-testid={TESTIDS.testimonials.section}
      className="relative py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className={`${r.className} max-w-2xl mb-14`}>
          <p className="text-[0.78rem] tracking-[0.22em] uppercase text-accent-magenta mb-4">
            Testimonios
          </p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.4rem] text-editorial-dark leading-[1.05]">
            Procesos que se atrevieron a
            <span className="italic text-terracotta"> sentirse</span>.
          </h2>
          <p className="mt-5 text-editorial-gray text-[1.02rem] leading-relaxed">
            Voces de personas que han compartido conmigo su proceso terapéutico. Sus nombres
            han sido modificados para resguardar su intimidad.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={i}
              data-testid={TESTIDS.testimonials.card(i)}
              className={`relative rounded-[2rem] border p-8 md:p-10 ${TONES[t.tone]} hover:-translate-y-1 transition-transform duration-500`}
            >
              <Quote
                size={28}
                className="text-accent-magenta/70 mb-5"
                strokeWidth={1.4}
              />
              <p className="font-serif text-[1.35rem] md:text-[1.45rem] text-editorial-dark leading-[1.4] italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-7 flex items-center gap-3">
                <span className="inline-flex w-10 h-10 rounded-full bg-warm-white text-accent-magenta items-center justify-center font-serif text-lg">
                  {t.name[0]}
                </span>
                <div>
                  <p className="font-medium text-editorial-dark text-sm">{t.name}</p>
                  <p className="text-xs text-editorial-gray">{t.role}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
